<template>
    <div class="sidebar__section__title">{{ competitionsName ?? "Probíhající soutěže" }}</div>
    <div class="ongoing-contests-wrapper ongoing-contests-wrapper--sidebar">
        <div class="ongoing-contests" :class="{ open: open }">
            <div class="contest-links contest-links--sidebar">
                <OngoingContestsLink
                    @click="sendAnalytics(contest.name, index)"
                    v-for="(contest, index) in contests"
                    :key="contest.id"
                    :link-suffix="contest.slug"
                    :type="contest.type"
                    :icon="contest.icon"
                    :name="contest.name"
                    :sub-text="contest.subText"
                />
                <OngoingContestsLink type="info" icon="cup-star" name="Všechny soutěže" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import useNavigation from "@/shared/composables/use-navigation";
import OngoingContestsLink from "@/header/components/atoms/OngoingContestsLink.vue";
import analytics from "@/shared/analytics";
import { SbContest } from "@/shared/model/contests";

const { competitionsName } = useNavigation();
const open = ref(false);

defineProps<{
    contests: SbContest[];
}>();

const sendAnalytics = (name: string, index: number) => {
    analytics.sendSideMenuClick(name, index);
};
</script>
